export const pluralize = (
  count: number,
  forms: [string, string, string]
): string => {
  const n = Math.abs(count) % 100;
  const lastDigit = n % 10;

  if (n >= 11 && n <= 14) return forms[2];
  if (lastDigit === 1) return forms[0];
  if (lastDigit >= 2 && lastDigit <= 4) return forms[1];

  return forms[2];
};